import React from "react";
import { Outlet } from "react-router-dom";
const LayoutWithOutConnect = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutWithOutConnect;
